<div class="test-result-profile" *ngIf="content && testResult">
  <div class="left-column">
    <h2 class="title">{{ content.fields.co2eTitle }}</h2>
    <div class="co2e">
      <strong class="co2e__number">{{ testResult.co2e | round: -1 }}</strong>
      <span class="co2e__label">kg CO₂e</span>
    </div>
    <div class="co2e-explanation">
      <!-- required field in contentful, but currently disabled in template -->
      <img
        *ngIf="false"
        class="co2e-explanation__icon"
        [src]="content.fields.co2eIcon.fields.file.url"
        [alt]="content.fields.co2eIcon.fields.description || ''"
        loading="lazy"
      />
      <div class="co2e-explanation__text">
        {{ content.fields.co2eLowerText }}
      </div>
    </div>

    <a class="link link--desktop" [routerLink]="content.fields.linkUrl">{{ content.fields.linkText }}</a>
  </div>
  <div class="right-column">
    <app-test-result-category-chart [testResult]="testResult"></app-test-result-category-chart>

    <a class="link link--mobile" [routerLink]="content.fields.linkUrl">{{ content.fields.linkText }}</a>
  </div>
</div>
